import React from 'react'

import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router'
import Flex, { FlexItem } from 'styled-flex-component'

import { IApplicationState } from '@store'
import {
  selectFirstPublishedDateText,
  selectLastPublishedDateText,
  selectShowCampaignReportTitleDates,
} from '@store/postCampaignReport'
import { selectCampaignId } from '@store/router'
import Theme from '@theme'
import { H3, Header } from '@tribegroup'
import PostCampaignReportTitleButton from './Button/Button'

export const PostCampaignReportTitle: React.FC = () => {
  const match = useRouteMatch()
  const campaignId = selectCampaignId(match)!
  const firstPublishedDateText = useSelector((state: IApplicationState) =>
    selectFirstPublishedDateText(state, campaignId),
  )
  const lastPublishedDateText = useSelector((state: IApplicationState) =>
    selectLastPublishedDateText(state, campaignId),
  )
  const showCampaignReportTitleDates = useSelector((state: IApplicationState) =>
    selectShowCampaignReportTitleDates(state, campaignId),
  )

  return (
    <Flex justifyBetween>
      <FlexItem>
        <H3 color={Theme.grey900Color} bottomOuterSpacing={0.5}>
          <FormattedMessage id="postCampaignReport.header.title" />
        </H3>
        {showCampaignReportTitleDates && (
          <Header
            data-testid="pcr-header"
            small
            uppercase
            color={Theme.grey700Color}
            bottomOuterSpacing={0.5}
          >
            <FormattedMessage
              id="postCampaignReport.header.subtitle"
              values={{ firstPublishedDateText, lastPublishedDateText }}
            />
          </Header>
        )}
      </FlexItem>
      <FlexItem>
        <PostCampaignReportTitleButton />
      </FlexItem>
    </Flex>
  )
}

export default PostCampaignReportTitle
